
import React, { useEffect, useRef, useState } from "react";
import about from "../Images/About.jpeg";
import image7 from "../Images/image7.jpeg";
import { FaTools, FaSmile, FaCrown } from "react-icons/fa"
import Header from "./Header";
import Footer from "./Footer";

const AboutBanner = () => {


  const data = [
  {
    id: "01",
    title: "Quality Pipes Supply",
    desc:
      "We supply premium quality pipes suitable for residential, commercial, and industrial applications, ensuring durability and long-term performance.",
    icon: <FaTools />,
    bg: "#f4f8ff",
  },
  {
    id: "02",
    title: "Pumps & Motors",
    desc:
      "Wide range of pumps and motors available in different capacities, selected based on usage, efficiency, and safety requirements.",
    icon: <FaSmile />,
    bg: "#eef4ff",
  },
  {
    id: "03",
    title: "Cables & Electrical Products",
    desc:
      "We offer reliable electrical cables and accessories that meet industry standards for safe and efficient power distribution.",
    icon: <FaCrown />,
    bg: "#e3edff",
  },
];

   
  const [count, setCount] = useState(0);
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    const end = 15;
    const duration = 1500;
    const startTime = performance.now();

    const animate = (currentTime) => {
      const progress = Math.min((currentTime - startTime) / duration, 1);
      setCount(Math.floor(progress * end));
      if (progress < 1) requestAnimationFrame(animate);
    };

    requestAnimationFrame(animate);
  }, []);

  return (
  <>
  <Header/>
    <section
      className="d-flex align-items-center justify-content-center text-center"
      style={{
        minHeight: "60vh",
        backgroundImage:
          "linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url('https://plus.unsplash.com/premium_photo-1661373713949-510c1f0af83f?q=80&w=1471&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="container text-white">
        <h1 className="fw-bold display-5 mb-3">About Us</h1>

        <hr className="mx-auto" style={{ maxWidth: "300px", opacity: 0.4 }} />

        <div className="d-inline-flex align-items-center justify-content-center bg-dark bg-opacity-50 px-3 py-2 rounded">
          <span className="me-2">Home</span>
          <span className="text-warning">About Us</span>
        </div>
      </div>
    </section>
    <section className="py-5">
          <div className="container">
    
            {/* ROW – stretch for equal height */}
            <div className="row align-items-stretch">
    
              {/* LEFT IMAGE */}
              <div className="col-lg-6 mb-4 mb-lg-0 d-flex">
                <div
                  className="w-100 position-relative"
                  style={{
                    height: "420px",         
                    borderRadius: "16px",
                    overflow: "hidden",
                  }}
                >
                  {/* COUNTER BOX */}
                  <div
                    className="position-absolute text-white text-center"
                    style={{
                      top: "20px",
                      left: "20px",
                      background: "#0d6efd",
                      padding: "15px 20px",
                      borderRadius: "12px",
                      zIndex: 2,
                    }}
                  >
                    <h2 className="mb-1">{count}+</h2>
                    <p className="mb-0">
                      Years Experience <br /> In Industrial Supplies
                    </p>
                  </div>
    
                  {/* IMAGE */}
                  <img
                    src={about}
                    alt="About Baba Industries"
                    className="w-100 h-100"
                    style={{ objectFit: "cover" }}
                  />
                </div>
              </div>
    
              {/* RIGHT CONTENT */}
              <div className="col-lg-6 ps-lg-5 d-flex">
                <div className="d-flex flex-column justify-content-between w-100">
    
                  <div>
                    <span className="fw-bold text-primary">ABOUT US</span>
    
                    <h2 className="fw-bold mt-3">
                      Supplying Quality Pipes, Motors & Cables You Can Trust
                    </h2>
    
                    <p className="mt-3 text-muted">
                   We are a trusted supplier of premium quality pipes, motors, and electrical cables, serving industrial, commercial, and residential projects. Our products are known for durability, efficiency, and long-lasting performance.

With a strong focus on quality and customer satisfaction, we source our materials from reliable manufacturers and ensure every product meets industry standards.
                    </p>
    
                
                  </div>
    
                  {/* SERVICE BOXES */}
                  <div className="row mt-4">
                    <div className="col-md-6 mb-3">
                      <div className="p-4 bg-light rounded h-100">
                        <h5>Pipe Supply</h5>
                        <p className="mb-0">
                          High-quality pipes for industrial and construction use.
                        </p>
                      </div>
                    </div>
    
                    <div className="col-md-6 mb-3">
                      <div className="p-4 bg-light rounded h-100">
                        <h5>Motors & Cables</h5>
                        <p className="mb-0">
                          Reliable motors and electrical cables for all applications.
                        </p>
                      </div>
                    </div>
                  </div>
    
                </div>
              </div>
    
            </div>
          </div>
        </section>

        <section className="py-5">
      <div className="container">
        <div className="row align-items-center">

          {/* LEFT IMAGE */}
          <div className="col-md-6 position-relative mb-4 mb-md-0">
            <img
              src={image7}
              alt="Best Approach"
              className="img-fluid rounded-4"
            />

            {/* Happy Client Box */}
            <div
              className="position-absolute bg-white shadow p-4 rounded-4"
              style={{ bottom: "20px", left: "20px", width: "220px" }}
            >
              <h2 className="fw-bold text-primary mb-0">30+</h2>
              <p className="mb-0 fw-semibold">Happy Client</p>
            </div>
          </div>

          {/* RIGHT CONTENT */}
          <div className="col-md-6">
            <h2 className="fw-bold mb-3">Our Best Approach</h2>

            <p className="text-muted">
                 We specialize in supplying high-quality pumps, motors, electrical cables,
    and pipes for residential, commercial, and industrial applications.
    Our focus is on delivering reliable products that ensure efficiency,
    safety, and long-term performance.
            </p>

            <ul className="list-unstyled mt-4">
              <li className="mb-3">
                <span className="text-primary fw-bold me-2">»</span>
                      Wide Range of Pumps, Motors, Cables, and Pipes
              </li>
              <li className="mb-3">
                <span className="text-primary fw-bold me-2">»</span>
              
      Products Selected Based on Usage, Capacity, and Safety
              </li>
              <li>
                <span className="text-primary fw-bold me-2">»</span>
                Trusted Quality with Competitive Pricing
              </li>
            </ul>
          </div>

        </div>
      </div>
    </section>



    <section className="container my-5">
      <div className="row rounded-4 overflow-hidden">

        {data.map((item, index) => (
          <div
            key={index}
            className="col-md-4 p-4"
            style={{ background: item.bg }}
          >
            {/* Top */}
            <div className="d-flex justify-content-between align-items-start mb-4">
              <div
                className="d-flex align-items-center justify-content-center"
                style={{
                  width: "50px",
                  height: "50px",
                  borderRadius: "50%",
                  background: "#2f6fff",
                  color: "#fff",
                  fontSize: "20px",
                }}
              >
                {item.icon}
              </div>

              <h2
                className="fw-bold"
                style={{
                  color: "#2f6fff",
                  opacity: 0.3,
                }}
              >
                {item.id}
              </h2>
            </div>

            {/* Content */}
            <h5 className="fw-bold mb-3">{item.title}</h5>
            <p className="text-muted mb-0">{item.desc}</p>
          </div>
        ))}

      </div>
    </section>
    <Footer/>
    </>
    
  );
};

export default AboutBanner;
